import NativeSelect from "@material-ui/core/NativeSelect";
import styled from "styled-components";

export const StyledSelect = styled(NativeSelect)`
  && {
    padding-left: 0px;
    padding-right: 5px;
    padding-bottom: 0px;
    select {
      padding: 1rem 2rem 1rem 1rem;
    }
    &:before {
      border-bottom-width: 0px !important;
    }
    &:after {
      border-bottom-width: 0px !important;
    }
  }
`;
